import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-os',
  templateUrl: './os.component.html',
  styleUrls: ['./os.component.scss']
})
export class OSComponent implements OnInit {
  course_details = environment.course_date_advanced_data_science_and_AI;
  certificateImage = 'assets/img/live-courses/certificate/OperatingSystems.png';

  course_class_mode_text = [
    '🔴 Live Interactive Sessions',
    '🎥 Access to Class Recordings',
    '❓Dedicated Doubt Support',
    '🏆 Course Certification',
    '🛠 Hands-on Project Work',
    '🎁 Final Assessment with Exciting Goodies'
  ]
  currentTextIndex: number = 0;
  classFeature: string = this.course_class_mode_text[this.currentTextIndex];

  mentor = {
    name: 'Sayan Naskar',
    title2: '',
    title: 'Software Engineer at Microsoft',
    image: 'assets/img/live-courses/sayan.jpg', // Update with actual image path
    linkedinUrl: 'https://www.linkedin.com/in/nascarsayan/'
  };

  stats = [
    { value: '2000+', label: 'Students Mentored' },
    { value: 'Software Engineer at Microsoft', label: 'Dual Degree,  IIT KGP' },

  ];

  constructor(private route: ActivatedRoute,
    private modalService: ModalService) { }

  ngOnInit(): void {
    setInterval(() => {
      this.currentTextIndex = (this.currentTextIndex + 1) % this.course_class_mode_text.length;
      this.classFeature = this.course_class_mode_text[this.currentTextIndex];
    }, 3000);
  }


  moduleArray = [
    {
      id: 1,
      active: false,
      courseTopic: 'OS Fundamentals & Process Basics',
      timeTaking: '1st week',
      isProjectInclude: false,
      childProperties: [
        {
          id: 1,
          module_description: 'Establish a robust data-driven groundwork with the first module, Foundations of Data Science.',
          moduleContant: [
            {
              topicName: 'Topics',
              subTopics: [
                'Overview of operating system roles and abstractions.',
                'Process concepts: processes vs. threads, system calls, and process lifecycle.',
                'An introduction to how shells work.'
              ]
            },
            {
              topicName: 'Theory Exercises',
              subTopics: [
                'Define the key responsibilities of an operating system.',
                'Explain the process lifecycle and discuss the role of system calls.',
                'Read assigned introductory chapters to build a foundation in OS theory.'
              ]
            },
            {
              topicName: 'Lab Exercise',
              subTopics: [
                'Mini Unix Shell – Part I: Create a simple command interpreter that reads user input and executes commands using fork/exec. This lays the groundwork for more complex shell design tasks.',
              ]
            }
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                ''
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 2,
      active: false,
      courseTopic: 'Processes, Threads & Basic Scheduling',
      timeTaking: '2nd week',
      isProjectInclude: false,
      childProperties: [
        {
          id: 1,
          module_description: 'Establish a robust data-driven groundwork with the first module, Foundations of Data Science.',
          moduleContant: [
            {
              topicName: 'Topics',
              subTopics: [
                'In-depth exploration of process creation and termination.',
                'Introduction to threads: their purpose and implementation',
                'Basic scheduling: context switching and an overview of scheduling algorithms.'
              ]
            },
            {
              topicName: 'Theory Exercises',
              subTopics: [
                'Compare and contrast processes and threads.',
                'Outline different scheduling strategies and discuss their trade‑offs',
              ]
            },
            {
              topicName: 'Lab Exercise',
              subTopics: [
                'Shell Enhancement: Extend the Unix shell from Week 1 to support background execution and basic job control. Implement signal handling to manage process termination effectively.',
              ]
            }
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                ''
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 3,
      active: false,
      courseTopic: 'Concurrency & Synchronization',
      timeTaking: '3rd week',
      isProjectInclude: false,
      childProperties: [
        {
          id: 1,
          module_description: 'Establish a robust data-driven groundwork with the first module, Foundations of Data Science.',
          moduleContant: [
            {
              topicName: 'Topics',
              subTopics: [
                'Understanding concurrency issues: race conditions and critical sections.',
                'Synchronization primitives: mutexes, semaphores, and condition variables.',
                ' A review of deadlock: conditions, detection, and prevention strategies.'
              ]
            },
            {
              topicName: 'Theory Exercises',
              subTopics: [
                'Describe a scenario where a race condition might occur and propose a mitigation strategy.',
                'Analyze the conditions that lead to deadlock and suggest methods for prevention or recovery.',
              ]
            },
            {
              topicName: 'Lab Exercise',
              subTopics: [
                'Multithreading Challenge: Develop a multithreaded application that demonstrates concurrent access to shared resources. Implement appropriate locking mechanisms to avoid race conditions.',
              ]
            }
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                ''
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 4,
      active: false,
      courseTopic: 'Interprocess Communication (IPC)',
      timeTaking: '4th week',
      isProjectInclude: false,
      childProperties: [
        {
          id: 1,
          module_description: 'Establish a robust data-driven groundwork with the first module, Foundations of Data Science.',
          moduleContant: [
            {
              topicName: 'Topics',
              subTopics: [
                'Overview of IPC mechanisms: pipes, message queues, shared memory, and sockets.',
                'Criteria for selecting the appropriate IPC method.',
                'The significance of IPC in modern operating system design.'
              ]
            },
            {
              topicName: 'Theory Exercises',
              subTopics: [
                'Design a communication protocol between two processes using an IPC method of your choice.',
                'Compare the advantages and disadvantages of shared memory versus message passing.',
              ]
            },
            {
              topicName: 'Lab Exercise',
              subTopics: [
                'Client-Server Shell Extension: Modify your shell or develop a separate mini‑project that uses IPC (for example, implementing a simple client-server model with sockets or pipes) to enable communication between processes.',
              ]
            }
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                ''
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 5,
      active: false,
      courseTopic: 'Memory Management & Virtual Memory',
      timeTaking: '5th week',
      isProjectInclude: false,
      childProperties: [
        {
          id: 1,
          module_description: 'Establish a robust data-driven groundwork with the first module, Foundations of Data Science.',
          moduleContant: [
            {
              topicName: 'Topics',
              subTopics: [
                'Fundamentals of memory management: allocation strategies, fragmentation, and paging.',
                'Virtual memory concepts: page tables, TLBs, and memory protection.',
                'The role of caching in optimizing performance.'
              ]
            },
            {
              topicName: 'Theory Exercises',
              subTopics: [
                'Explain how virtual memory abstracts the physical memory layer.',
                'Describe a simple paging system and illustrate the role of page tables in address translation.',
              ]
            },
            {
              topicName: 'Lab Exercise',
              subTopics: [
                'Memory Simulator: Write a program that simulates basic memory allocation, including page table creation and address translation, to reinforce your understanding of virtual memory mechanisms.',
              ]
            }
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                ''
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 6,
      active: false,
      courseTopic: 'Advanced Topics & Course Integration',
      timeTaking: '6th week',
      isProjectInclude: true,
      childProperties: [
        {
          id: 1,
          module_description: 'Establish a robust data-driven groundwork with the first module, Foundations of Data Science.',
          moduleContant: [
            {
              topicName: 'Topics',
              subTopics: [
                'File system fundamentals: data storage, metadata management, and file organization.',
                'I/O systems and device management.',
                'Advanced scheduling, performance tuning, and security considerations.',
                'Integration of OS components into a cohesive system.'
              ]
            },
            {
              topicName: 'Theory Exercises',
              subTopics: [
                'Propose a design for a basic file system, discussing both metadata management and data storage.',
                ' Analyze how different OS components (process management, memory management, IPC) interact to deliver a robust system.',
              ]
            },
            {
              topicName: 'Lab Exercise',
              subTopics: [
                ' Integrated OS Simulator: Combine elements from previous weeks into a capstone project. Enhance your shell to include file redirection, improved process management, and basic I/O operations. This project encourages you to integrate and apply the concepts learned throughout the course.',
              ]
            }
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                ''
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
  ]

  toggleCourseTitle(selectedData, index) {
    for (let i = 0; i < this.moduleArray.length; i++) {
      if (this.moduleArray[i].id == selectedData.id) {
        this.moduleArray[i].active = !this.moduleArray[i].active;
      } else {
        this.moduleArray[i].active = false;
      }
    }
  }

  downloadBroucher() {
    this.modalService.openModal();
  }
}
